import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PageTransition from '../components/PageTransition';
import VideoAccordion from '../components/VideoAccordion';
import { LanguageContext } from '../context/LanguageContext';

export default function AtelieAberto() {
  const { language } = useContext(LanguageContext);

  const texts = {
    EN: {
      title: 'Open Studio: Printmaking in Expanded Field',
      description: 'An immersive course exploring traditional and contemporary printmaking techniques.',
      courseInfo: {
        duration: 'Course Duration: 5 modules',
        format: 'Format: Online video lessons',
        access: 'Lifetime access to content'
      },
      back: "back"
    },
    PT: {
      title: 'Ateliê Aberto: Gravura no Campo Expandido',
      description: 'Um curso introdutório explorando técnicas tradicionais e contemporâneas de gravura.',
      courseInfo: {
        duration: 'Duração do Curso: 5 módulos',
        format: 'Formato: Videoaulas online',
        access: 'Acesso vitalício ao conteúdo'
      },
      back: "retornar"
    }
  };

  const t = texts[language];

  return (
    <PageTransition>
      <div className="page-container">
        <Link to="/workshops" className="back-button">&lt; {t.back}</Link>
        
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
          <h1 style={{ marginBottom: '20px' }}>{t.title}</h1>
          
          <p style={{ fontSize: '1.2em', marginBottom: '30px' }}>{t.description}</p>
          

          {/* Featured Video */}
          <div style={{ marginBottom: '40px' }}>
            <h3>Apresentação</h3>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  borderRadius: '8px'
                }}
                src="https://www.youtube.com/embed/Q5fnpydvPAU"
                title="Apresentação"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>

          {/* Course Content */}
          <div style={{ marginTop: '40px' }}>
            <h2 style={{ marginBottom: '20px' }}>Conteúdo do Curso</h2>
            <VideoAccordion />
          </div>
        </div>
      </div>
    </PageTransition>
  );
}